import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";
import * as moment from "moment";

export const beneficiary_change_isp_component =  {
    beneficiaries: null,
}

export const payment_form_validators = {
    beneficiaries: null,
};


export interface IPrevidentialBeneficiaryType {
    c_tipo_beneficiario?: string;
    c_beneficiario?: string;
    descrizione?: string;
    ordine?: number;
}

export interface IPrevidentialBeneficiaryViewModel {
    description?: string;
}


export interface IBeneficiaryRequestPrevidential {
    beneficiario: IPrevidentialRequestModel[];
    anagrafichePrevidenziali?: IPrevidentialAnagraficaRequestModel[];
}

export interface IPrevidentialRequestModel {
    codicebeneficiario: string;
    codiceTipoBeneficiario?: string;
    relazione?: string;
    relazioneDescrizione?: string;
    nome?: string;
    cognome?: string;
    tipoPersona?: 'F' | 'G';
    codiceFiscale?: string;
    ragioneSociale?: string;
    partitaIVA?: string;
    dataNascita?: string;
    localitaNascita?: string;
    nazioneNascita?: string;
    provinciaNascita?: string;
    perc_Beneficiorio?: string;
    indirizzo_alternativo?: string;
    indirizzo_postale?: string;
    localita_postale?: string;
    localita_provincia?: string;
    localita_cap?: string;   
    personType?: string;
}

export interface IPrevidentialAnagraficaRequestModel {
    cognome?: string;
    nome?: string;
    sesso?: string;
    codiceFiscale?: string;
    dataNascita?: string;
    indirizzoNascita?: IPrevidentialIndirizzoNascitaRequestModel;
    naturaGiuridica?: 'F' | 'G';
    codiceAteco?: string;
    indirizzo?: IPrevidentialIndirizzoNascitaRequestModel;
    recapitiTelefonici?
    idAnagrafico?: string;
    documento?: any;
}

export interface IPrevidentialIndirizzoNascitaRequestModel {
    cap?: string;
    idAnagrafico?: string;
    via?: string;
    localita?: string;
    provincia?: string;
    codiceNazione?: string;
    nazione?: string;
}

export interface IPrevidentialRecapitiTelefoniciRequestModel {
    n_telefonico?: string;
    nominativo_intestatario?: string;
    descrizione_strumento?: string;
}


export const beneficiary_change_form_keys_previdential_intros: IFormKey[] = [
  {
    id: 'effectDate-field',
    label: 'Data di effetto',
    controlName: 'effectDate',
    css: 'col-6',
    type: 'DATEPICKER',
    minDate: moment()
  }
];

export const beneficiary_change_form_template_previdential_intros = {
    effectDate: moment()
}

export const beneficiary_change_form_validators_previdential_intros = {
  effectDate: [Validators.required]
}
